import { render } from "./Loader.vue?vue&type=template&id=0c3dc092&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=0c3dc092&scoped=true&lang=scss"
import "./Loader.vue?vue&type=style&index=1&id=0c3dc092&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3dc092"]])

export default __exports__